<template>
  <div v-if="resolvedLinks.length" class="item-links" :class="{ 'item-links--compact': compact }">
    <component :is="headingTag" v-if="title" class="item-links-title">{{ title }}</component>
    <div class="item-links-list">
      <a
        v-for="link in resolvedLinks"
        :key="link.url"
        :href="link.url"
        target="_blank"
        rel="noopener noreferrer"
        class="item-link"
      >
        <span class="item-link-prefix">→</span>
        <span class="item-link-text">
          <span class="code-keyword">link</span>:
          <span class="code-string">"{{ link.label }}"</span>
        </span>
      </a>
    </div>
  </div>
</template>

<script>
import { getItemLinks } from '../utils/itemLinks';

export default {
  name: 'ItemLinks',
  props: {
    items: {
      type: Object,
      default: null,
    },
    links: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: 'Links',
    },
    compact: {
      type: Boolean,
      default: false,
    },
    headingTag: {
      type: String,
      default: 'h5',
    },
  },
  computed: {
    resolvedLinks() {
      if (this.links) {
        return this.links;
      }
      return getItemLinks(this.items);
    },
  },
};
</script>

<style scoped>
.item-links {
  margin-top: 1.5rem;
}

.item-links--compact {
  margin-top: 1rem;
}

.item-links-title {
  color: #569cd6;
  margin: 0 0 0.75rem 0;
  font-size: 1rem;
  font-weight: 600;
}

.item-links-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.item-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.85rem;
  border-radius: 4px;
  text-decoration: none;
  background-color: #1e1e1e;
  border: 1px solid #0078d4;
  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.item-link:hover {
  background-color: #2a3a4a;
  border-color: #4ec9b0;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 120, 212, 0.25);
}

.item-link-prefix {
  color: #4ec9b0;
  font-size: 0.9rem;
}

.item-link-text {
  font-size: 0.85rem;
  white-space: nowrap;
}

.code-keyword {
  color: #569cd6;
}

.code-string {
  color: #ce9178;
}
</style>
